import { render, staticRenderFns } from "./AffiliateLinkTable.vue?vue&type=template&id=d33275e4&scoped=true"
import script from "./AffiliateLinkTable.vue?vue&type=script&lang=js"
export * from "./AffiliateLinkTable.vue?vue&type=script&lang=js"
import style0 from "./AffiliateLinkTable.vue?vue&type=style&index=0&id=d33275e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33275e4",
  null
  
)

export default component.exports